import { tabs } from '../../../../../../views/dashboard/company/CompanyDashboard';

export default {
  title: 'Panel główny',
  tabs: {
    [tabs.general]: 'Ogólne',
    [tabs.overview]: 'Przegląd',
    [tabs.orders]: 'Zamówienia wg źródła',
    [tabs.google]: 'Google',
    [tabs.customers]: 'Klienci',
    [tabs.order_conversion]: 'Konwersja zamówień',
    [tabs.mobile_app]: 'Aplikacja mobilna',
  },
  date_range: {
    this_month: 'Ten miesiąc',
    last_month: 'Poprzedni miesiąc',
    last_week: 'Poprzedni tydzień',
    this_week: 'Ten tydzień',
    this_year: 'Ten rok',
    last_year: 'Poprzedni rok',
    today: 'Dzisiaj',
    yesterday: 'Wczoraj',
    all: 'Wszystkie',
  },
  buttons: {
    view_key_info: 'Pokaż kluczowe informacje',
  },
  empty_franchise: {
    description: 'Ta marka nie ma jeszcze restauracji. Wybierz inną markę w menu, aby zobaczyć jej statystyki.',
  },
};
